import { Proposition } from './proposition';

export const MOCKPROPOSITIONS: Proposition[] = [
  {
    title: 'Husqvarna',
    icon: '',
    image: 'http://i3.ytimg.com/vi/Yx_10PPKXRg/maxresdefault.jpg',
    today: 'Leading provider of high quality gear',
    tomorrow: 'Supplier of sustainable green spaces',
    next: 'Supplier of sustainable green spaces',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/value-proposition/propositions/mock-propositions.ts